import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { GET, POST, PUT } from "../../helpers/apiHelper";
import * as action from "./actions";
import i18n from "../../i18n";

const loadOauthKeyListAsync = (params) => {
  const q = new URLSearchParams();
  q.set("page", params.selectedPage || params.page || 1);
  q.set("limit", params.limit || 10);
  if (params.appName) q.set("appName", params.appName);
  return GET(`/oauth-key/getAll?${q.toString()}`);
};

const getOauthKeyByIdAsync = (id) => GET(`/oauth-key/getById/${id}`);
const storeOauthKeyAsync = (item) => POST(`/oauth-key/store`, item, { idempotent: true });
const updateOauthKeyAsync = (id, item) => PUT(`/oauth-key/update/${id}`, item);
const deleteOauthKeyAsync = (ids) => POST(`/oauth-key/destroy`, { ids });

function* loadOauthKeyList({ payload }) {
  try {
    const response = yield call(loadOauthKeyListAsync, payload);
    yield put(action.loadOauthKeyListSuccess(response));
  } catch (error) {
    yield put(action.loadOauthKeyListError(error?.response?.data?.message || error));
  }
}

function* saveAddEditOauthKey({ payload }) {
  try {
    if (!payload.item) {
      throw new Error(i18n.t("oauthKey.alert.invalidSaveItem"));
    }
    const { item, mode, history } = payload;
    if (mode === "edit" && item.id) {
      const { id, clientSecret, ...rest } = item;
      const updatePayload = { ...rest };
      if (clientSecret && clientSecret.trim()) {
        updatePayload.clientSecret = clientSecret.trim();
      }
      yield call(updateOauthKeyAsync, id, updatePayload);
    } else {
      yield call(storeOauthKeyAsync, item);
    }
    yield put(action.saveAddEditOauthKeySuccess());
    yield put(action.loadOauthKeyList({}));
    if (history?.push) {
      history.push("/oauth-key-management");
    }
  } catch (error) {
    const msg = error?.response?.data?.message || error?.message || String(error);
    yield put(action.saveAddEditOauthKeyError(msg));
  }
}

function* deleteOauthKey({ payload }) {
  try {
    if (payload?.confirmed && payload?.item?.length) {
      yield call(deleteOauthKeyAsync, payload.item);
      yield put(action.deleteOauthKeySuccess());
      yield put(action.loadOauthKeyList({}));
    }
  } catch (error) {
    const msg = error?.response?.data?.message || error?.message || String(error);
    yield put(action.deleteOauthKeyError(msg));
  }
}

export function* watchLoadOauthKeyList() {
  yield takeEvery(action.OAUTH_KEY_GET_LIST, loadOauthKeyList);
}
export function* watchSaveAddEditOauthKey() {
  yield takeEvery(action.OAUTH_KEY_SAVE_ADD_EDIT, saveAddEditOauthKey);
}
export function* watchDeleteOauthKey() {
  yield takeEvery(action.OAUTH_KEY_DELETE, deleteOauthKey);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoadOauthKeyList),
    fork(watchSaveAddEditOauthKey),
    fork(watchDeleteOauthKey),
  ]);
}
